// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_mi-0";